import { render, staticRenderFns } from "./UserNew.vue?vue&type=template&id=6c5f724d&scoped=true"
import script from "./UserNew.vue?vue&type=script&lang=js"
export * from "./UserNew.vue?vue&type=script&lang=js"
import style0 from "./UserNew.vue?vue&type=style&index=0&id=6c5f724d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f724d",
  null
  
)

export default component.exports